<template>
  <div>
    <!-- 面包屑导航 -->
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item :to="{ path: '/base/index' }">首页</el-breadcrumb-item>
      <el-breadcrumb-item>云影像查询</el-breadcrumb-item>
    </el-breadcrumb>
    <el-form :inline="true" :model="formInline" class="user-search" style="margin-top: 20px;">
      <el-date-picker
            v-model="formInline.yxq"
            type="daterange"

            value-format="yyyy-MM-dd"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
            >
          </el-date-picker>
      </el-form-item>
      <el-form-item>
        <el-button size="small" type="primary" icon="el-icon-search" @click="search">搜索</el-button>
        <el-button size="small" type="primary" icon="el-icon-refresh-left" @click="formReset()">重置</el-button>

      </el-form-item>
    </el-form>
    <!-- 新闻列表 -->
    <div  style="width: 100%;height: auto;background-color: white;margin-top: 10px;">

      <el-table size="small" :header-cell-style="{background:'#00A0FF',color:'white',border: '1px solid tan'}"
    :row-class-name="tableRowClassName"  :data="listData" highlight-current-row v-loading="loading" border element-loading-text="拼命加载中" style="width: 100%;margin-top: 30px;margin: 0 auto;">
         <el-table-column align="center" type="index" width="60" >
         </el-table-column>
         <el-table-column prop="date" align="center" label="日期" width="300">
            <template slot-scope="scope">
             <div  @click="cxqx(scope.row,2)">
               {{scope.row.ksrq}} 至  {{scope.row.jsrq}}
             </div>

            </template>
         </el-table-column>
         <el-table-column prop="count" align="center" label="人数" width="300">
           <template slot-scope="scope">
             {{scope.row.zrs}}

           </template>
         </el-table-column>
         <el-table-column prop="all_count" align="center" label="人次" width="300">
          <template slot-scope="scope">

            {{scope.row.zrc}}


          </template>
         </el-table-column>


      <!--   <el-table-column fixed="right" label="操作" align="center" width="100">
           <template slot-scope="scope">
             <router-link :to="{ path: '/news/article/'+scope.row.id }" type="text" size="small">编辑</router-link>
             <el-button @click="deleteNews(scope.row.id)" type="text" size="small" style="margin-left: 10px;">删除</el-button>
           </template>
         </el-table-column> -->
       </el-table>

    </div>

    <!-- 分页组件 -->


    <div style="width: 100%;height: 60px;">

    </div>
  </div>
</template>

<script>
  import Pagination from '../../components/Pagination'
  import { yyxlist,updateNews,delNews, yyxdetail} from '../../api/baseset'
  export default {
    data() {
      return {
        loading: false, //是显示加载
        formInline: {
          page: 1,
          limit: 10,
          yxq:''
        },
        // 分页参数
        pageparm: {
          currentPage: 1,
          pageSize: 10,
          total: 10
        },
        tjsj:{},
        listData: [], //表格数据
        sjtj:{}
      }
    },
    components:{
      Pagination
    },
    created() {
      console.log(55555)
      this.getdata(this.formInline)
    },
    methods: {
      getdata(parameter) {
        this.loading = true
        yyxlist(parameter).then(res => {
           console.log(res)
             this.loading = false
              this.listData = res.data
            //   console.log( this.listData)
            // this.tjsj = res.data.sjtj
            // 分页赋值
         /*   this.pageparm.currentPage = this.formInline.page
            this.pageparm.pageSize = this.formInline.limit
            this.pageparm.total = res.count */
          }
        ).catch(err => {
           this.loading = false
           this.$message.error('数据加载失败，请稍后再试！')
         })
      },
      search(){
        this.getdata(this.formInline)
      },
      deleteNews(id) {
        this.$confirm('您确定要删除新闻吗?', '信息', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          let data = {id:id}
          delNews(data).then(res => {
            if(res.code == 0){
              this.$message({
                type: 'success',
                message: res.msg
              })
              this.getdata(this.formInline)
            }else{
              this.$message.error(res.msg)
            }
          })

        }).catch(() => {
          this.$message({
            type: 'info',
            message: '已取消删除'
          })
        })
      },
      setswitch(type,row) {
        var data = {}
        if(type == 'is_show'){
          data = {id:row.id,is_show:row.is_show}
        }
        if(type == 'top'){
          data = {id:row.id,top:row.top}
        }
        updateNews(data).then(res => {
          if(res.code == 0){
            this.$message({
              type: 'success',
              message: res.msg
            })
          }else{
            this.$message.error(res.msg)
          }
        })
      },
      // 分页插件事件
      callFather(parm) {
        this.formInline.page = parm.currentPage
        this.formInline.limit = parm.pageSize
        this.getdata(this.formInline)
      },
      tableRowClassName({ row, rowIndex }) {
              if (rowIndex % 2 === 1) {
                return 'success-row' //这是类名
              } else  {
                return ''
              }
        },
        cxqx(row,status){

            console.log(row)
            this.$router.push('/yyx/yyxdetail/'+row.date); //jkcpxx


        }
    }
  }
</script>

<style>
  .jiahong{
    color: red;
  }
</style>



// WEBPACK FOOTER //
// src/views/yyx/yyxlist.vue